/**
 * Joins class names for Tailwind (filters falsy values).
 * Prefer over long ternary `className` strings (see Cursor rules).
 */
export const cn = (
  ...classes: Array<string | false | null | undefined>
): string => classes.filter(Boolean).join(" ");
